import React, {useState} from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuthContext } from '../../../hooks/useAuthContext';


const EditSOModal = (props) => {
    const [dateAdded, setDateAdded] = useState(props.watch.inventory ? props.watch.inventory.dateAdded.slice(0,10) : 'Never added to inventory');
    const [listPrice, setListPrice] = useState(props.watch.inventory ? `${props.watch.inventory.listPrice}` : 'No list price');
    const [brand, setBrand] = useState(props.watch.brand);
    const [model, setModel] = useState(props.watch.model);
    const [year, setYear] = useState(props.watch.year);
    const [size, setSize] = useState(props.watch.size);
    const [refNum, setRefNum] = useState(props.watch.refNum);
    const [serialNum, setSerialNum] = useState(props.watch.serialNum);
    const [condition, setCondition] = useState(props.watch.condition);
    const [box, setBox] = useState(props.watch.box);
    const [papers, setPapers] = useState(props.watch.papers);
    const [notes, setNotes] = useState(props.watch.notes);
    const [purDate, setPurDate] = useState(props.watch.purOrder.purDate);
    const [supplier, setSupplier] = useState(props.watch.purOrder.supplier);
    const [purStatus, setPurStatus] = useState(props.watch.purOrder.purStatus);
    const [purPrice, setPurPrice] = useState(props.watch.purOrder.purPrice);
    const [purNotes, setPurNotes] = useState(props.watch.purOrder.purNotes);
    const [saleDate, setSaleDate] = useState(props.watch.saleOrder.saleDate);
    const [salePrice, setSalePrice] = useState(props.watch.saleOrder.salePrice);
    const [saleCustomer, setSaleCustomer] = useState(props.watch.saleOrder.saleCustomer);
    const [shipToStreet, setShipToStreet] = useState(props.watch.saleOrder.shipToStreet);
    const [shipToCity, setShipToCity] = useState(props.watch.saleOrder.shipToCity);
    const [shipToState, setShipToState] = useState(props.watch.saleOrder.shipToState);
    const [shipToZip, setShipToZip] = useState(props.watch.saleOrder.shipToZip);
    const [saleNotes, setSaleNotes] = useState(props.watch.saleOrder.saleNotes);
    const [invoiced, setInvoiced] = useState(props.watch.saleOrder.invoiced);
    const [shipped, setShipped] = useState(props.watch.saleOrder.shipped);
    const [delivered, setDelivered] = useState(props.watch.saleOrder.delivered);
    const [error, setError] = useState(null);
    const {user} = useAuthContext(); //grabbing the user object that is returned from the useAuthContext hook
    const navigate = useNavigate();

    
    const handleSubmit = async (event) => {
        event.preventDefault();

        const editedWatch = {
            listPrice, dateAdded, brand, model, year, size, refNum, serialNum, condition,
            box, papers, notes, purDate, supplier, purStatus, purNotes, 
            purPrice, saleDate, salePrice, saleCustomer, shipToStreet, shipToCity, shipToState, shipToZip,
            saleNotes, invoiced, shipped, delivered
        }
        
        try {
            //edit SO
            await axios.patch(
                process.env.REACT_APP_SERVER_URL + '/api/saleOrders/update/' + props.watch._id, 
                editedWatch,
                {headers: {'Authorization': `Bearer ${user.token}`}}
            );
        } catch (e) {
            console.log(e.response.data.error);
            setError(e.response.data.error);
        }

        navigate('/main/home');
    }


    return (
        <form className="modal-form" onSubmit={user ? handleSubmit : null}>
            <div className="inputs-container">
                <div className="inner-form-container">
                    <label className="form-label">Brand</label>
                    <input
                        className="form-control" 
                        type="text"
                        onChange={(event) => setBrand(event.target.value)}
                        value={brand} 
                    />
                </div>

                <div className="inner-form-container">
                    <label className="form-label">Model</label>
                    <input
                        className="form-control" 
                        type="text"
                        onChange={(event) => setModel(event.target.value)}
                        value={model} 
                    />
                </div>

                <div className="inner-form-container">
                    <label className="form-label">Year</label>
                    <input
                        className="form-control" 
                        type="number"
                        onChange={(event) => setYear(event.target.value)}
                        value={year} 
                    />
                </div>

                <div className="inner-form-container">
                    <label className="form-label">Size</label>
                    <input
                        className="form-control" 
                        type="string"
                        onChange={(event) => setSize(event.target.value)}
                        value={size} 
                    />
                </div>

                <div className="inner-form-container">
                    <label className="form-label">Reference Number</label>
                    <input
                        className="form-control" 
                        type="string"
                        onChange={(event) => setRefNum(event.target.value)}
                        value={refNum} 
                    />
                </div>

                <div className="inner-form-container">
                    <label className="form-label">Serial Number</label>
                    <input
                        className="form-control" 
                        type="string"
                        onChange={(event) => setSerialNum(event.target.value)}
                        value={serialNum} 
                    />
                </div>

                <div className="inner-form-container">
                    <label className="form-label">Condition</label>
                    <select
                        className="form-select"
                        onChange={(event) => setCondition(event.target.value)}
                        value={condition} 
                    > 
                        <option value="New">New</option>
                        <option value="Preowned">Preowned</option>
                    </select>
                </div>

                <div className="inner-form-container">
                    <label className="form-label">Box</label>
                    <select
                        className="form-select"
                        onChange={(event) => setBox(event.target.value)}
                        value={box} 
                    > 
                        <option value="true">Yes</option>
                        <option value="false">No</option>
                    </select>
                </div>

                <div className="inner-form-container">
                    <label className="form-label">Papers</label>
                    <select
                        className="form-select"
                        onChange={(event) => setPapers(event.target.value)}
                        value={papers} 
                    > 
                        <option value="true">Yes</option>
                        <option value="false">No</option>
                    </select>
                </div>

                <div className="inner-form-container">
                    <label className="form-label">Notes</label>
                    <textarea
                        className="form-control"
                        onChange={(event) => setNotes(event.target.value)}
                        value={notes}
                        rows={4}
                        cols={40}
                    />
                </div>
            </div>

            <h3>Sale Order Details</h3>
            <div className="inputs-container">
                <div className="inner-form-container">
                    <label className="form-label">Sale Date</label>
                    <input 
                        className="form-control"
                        type="date"
                        onChange={(event) => setSaleDate(event.target.value)}
                        value={saleDate} 
                    />
                </div>

                <div className="inner-form-container">
                    <label className="form-label">Sale Price</label>
                    <input
                        className="form-control" 
                        type="number"
                        onChange={(event) => setSalePrice(event.target.value)}
                        value={salePrice} 
                    />
                </div>

                <div className="inner-form-container">
                    <label className="form-label">Sale Customer</label>
                    <input
                        className="form-control" 
                        type="string"
                        onChange={(event) => setSaleCustomer(event.target.value)}
                        value={saleCustomer} 
                    />
                </div>

                <div className="inner-form-container">
                    <label className="form-label">Ship To Street</label>
                    <input
                        className="form-control" 
                        type="string"
                        onChange={(event) => setShipToStreet(event.target.value)}
                        value={shipToStreet} 
                    />
                </div>

                <div className="inner-form-container">
                    <label className="form-label">Ship To City</label>
                    <input
                        className="form-control" 
                        type="string"
                        onChange={(event) => setShipToCity(event.target.value)}
                        value={shipToCity} 
                    />
                </div>

                <div className="inner-form-container">
                    <label className="form-label">Ship To State</label>
                    <input
                        className="form-control" 
                        type="string"
                        onChange={(event) => setShipToState(event.target.value)}
                        value={shipToState} 
                    />
                </div>

                <div className="inner-form-container">
                    <label className="form-label">Ship To Zip</label>
                    <input
                        className="form-control" 
                        type="string"
                        onChange={(event) => setShipToZip(event.target.value)}
                        value={shipToZip} 
                    />
                </div>

                <div className="inner-form-container">
                    <label className="form-label">Invoiced</label>
                    <select
                        className="form-select"
                        onChange={(event) => setInvoiced(event.target.value)}
                        value={invoiced} 
                    > 
                        <option value="true">Yes</option>
                        <option value="false">No</option>
                    </select>
                </div>

                <div className="inner-form-container">
                    <label className="form-label">Shipped</label>
                    <select
                        className="form-select"
                        onChange={(event) => setShipped(event.target.value)}
                        value={shipped} 
                    > 
                        <option value="true">Yes</option>
                        <option value="false">No</option>
                    </select>
                </div>

                <div className="inner-form-container">
                    <label className="form-label">Delivered</label>
                    <select
                        className="form-select"
                        onChange={(event) => setDelivered(event.target.value)}
                        value={delivered} 
                    > 
                        <option value="true">Yes</option>
                        <option value="false">No</option>
                    </select>
                </div>

                <div className="inner-form-container">
                    <label className="form-label">Sale Notes</label>
                    <textarea
                        className="form-control"
                        onChange={(event) => setSaleNotes(event.target.value)}
                        value={saleNotes}
                        rows={4}
                        cols={40}
                    />
                </div>
            </div>

            <h3>Inventory Details</h3>
            <div className="inputs-container">
                <div className="inner-form-container">
                    <label className="form-label">Date Added</label>
                    {props.watch.inventory ? <input className="form-control" type="date" onChange={(event) => setDateAdded(event.target.value)} value={dateAdded} /> : <p>Never added to inventory</p>}                
                </div>
                <div className="inner-form-container">
                    <label className="form-label">List Price</label>
                    {props.watch.inventory ? <input className="form-control" type="number" onChange={(event) => setListPrice(event.target.value)} value={listPrice}/> : <p>No list price</p>}
                </div>
            </div>

            <h3>Purchase Details</h3>
            <div className="inputs-container">
                <div className="inner-form-container">
                    <label className="form-label">Purchase Date</label>
                    <input className="form-control" type="date" onChange={(event) => setPurDate(event.target.value)} value={purDate}/>
                </div>

                <div className="inner-form-container">
                    <label className="form-label">Supplier Name</label>
                    <input
                        className="form-control"
                        type="text"
                        onChange={(event) => setSupplier(event.target.value)}
                        value={supplier} 
                    />
                </div>

                <div className="inner-form-container">
                    <label className="form-label">Purchase Status</label>
                    <select
                        className="form-select"
                        onChange={(event) => setPurStatus(event.target.value)}
                        value={purStatus} 
                    > 
                        <option value="Paid">Paid</option>
                        <option value="Received">Paid & Received</option>
                    </select>
                </div>

                <div className="inner-form-container">
                    <label className="form-label">Purchase Price</label>
                    <input
                        className="form-control" 
                        type="number"
                        onChange={(event) => setPurPrice(event.target.value)}
                        value={purPrice} 
                    />
                </div>

                <div className="inner-form-container">
                    <label className="form-label">Purchase Order Notes</label>
                    <textarea
                        className="form-control"
                        onChange={(event) => setPurNotes(event.target.value)}
                        value={purNotes}
                        rows={4}
                        cols={40}
                    />
                </div>
            </div>

            <button type="submit" className="btn btn-light">Edit Sale Order</button>
            {error && <div className="error">{error}</div>}
        </form>
    )
}

export default EditSOModal;